/**
 * Adds body class to check if JS is enabled
 * @returns {Boolean}
 */
function isJavascriptEnabled(){
    document.body.classList.add('has-javascript-enabled');
    return true;
}

exports.isJavascriptEnabled = isJavascriptEnabled;